import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { SharedModule } from '../shared/shared.module';

// Components
import { JobDetailsComponent } from './job-details/job-details.component';
import { InnerHtmlViewComponent } from '../shared/innerhtml.component';
import { GetSafeHTMLEmailPipe } from '../pipes/getSafeHTMLEmail.pipe';
import { CandidateListComponent } from './candidate-list/candidate-list.component';
import { EventOverviewComponent } from './event-overview/event-overview.component';
import { BreadcrumbModule } from "xng-breadcrumb";
import { TitleCaseUnderscorePipe } from '../pipes/titleCaseUnderscore.pipe';
import { Drawer } from "primeng/drawer";
import { Select } from "primeng/select";
import { AccordionModule } from 'primeng/accordion';
import { InviteCandidateV2Component } from "src/app/talentpool/invite-candidate-v2/invite-candidate-v2";


@NgModule({
  declarations: [
    CandidateListComponent,
    JobDetailsComponent,
    EventOverviewComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgCircleProgressModule.forRoot({
        radius: 15,
        outerStrokeWidth: 2,
        innerStrokeWidth: 1,
        outerStrokeColor: "#4882c2",
        innerStrokeColor: "#e7e8ea",
        animationDuration: 300,
        showSubtitle: false,
        showUnits: false,
        showBackground: false,
        startFromZero: false,
    }),
    BreadcrumbModule,
    TitleCaseUnderscorePipe,
    InnerHtmlViewComponent,
    GetSafeHTMLEmailPipe,
    Drawer,
    Select,
    AccordionModule,
    InviteCandidateV2Component
],
})
export class JobModule { }
